'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.tagsync', {
            url: '/admin/tagsync',
            templateUrl: 'dashboard-department-admin-tagsync/dashboard-department-admin-tagsync.html',
            controller: 'dashboardDepartmentAdminTagSyncCtrl as ctrl',
            resolve: {
            },
            data: {
                authorizedRoles: ['admin','owner','supervisor']
            }
        });
    $stateProvider
        .state('dashboard.departments.department.tagsyncImport', {
            url: '/admin/tagsync/:idGoogleSheet/:sheetName',
            templateUrl: 'dashboard-department-admin-tagsync/dashboard-department-admin-tagsync-import.html',
            controller: 'dashboardDepartmentAdminTagSyncImportCtrl as ctrl',
            resolve: {
            },
            data: {
                authorizedRoles: ['admin','owner','supervisor']
            }
        });
};
